<form
  [formGroup]="form"
  [bitSubmit]="submit"
  autocomplete="off"
  bit-dialog
  class="bv-account-dialog bv-security-keys-dialog"
>
  <span bitDialogTitle>{{ "changeKdf" | i18n }}</span>

  <div bitDialogContent>
    @if (!(noLogoutOnKdfChangeFeatureFlag$ | async) && showKdfWarning) {
      <div class="bv-security-warning-banner bv-security-keys-dialog__warning" role="alert">
        <bit-icon name="bwi-exclamation-triangle" class="bv-security-warning-banner__icon" />
        <div class="bv-security-warning-banner__content">
          <p class="bv-security-warning-banner__title">{{ "warning" | i18n }}</p>
          <p class="bv-security-warning-banner__message">
            {{ "kdfSettingsChangeLogoutWarning" | i18n }}
          </p>
        </div>
        <button
          type="button"
          bitIconButton="bwi-close"
          buttonType="subtleGhost"
          size="small"
          class="bv-security-warning-banner__close"
          [label]="'close' | i18n"
          (click)="showKdfWarning = false"
        ></button>
      </div>
    }

    <bit-form-field disableMargin class="bv-security-kdf-field">
      <bit-label>{{ "masterPass" | i18n }}</bit-label>
      <input bitInput type="password" formControlName="masterPassword" appAutofocus />
      <button
        type="button"
        bitIconButton
        bitSuffix
        bitPasswordInputToggle
        [(toggled)]="showPassword"
      ></button>
      <bit-hint>{{ "confirmIdentity" | i18n }}</bit-hint>
    </bit-form-field>
  </div>

  <ng-container bitDialogFooter>
    <div class="bv-account-dialog__footer">
      <div class="bv-account-dialog__footer-end">
        <button
          bitButton
          buttonType="secondary"
          type="button"
          bitFormButton
          bitDialogClose
          class="bv-account-dialog__cancel-btn"
        >
          {{ "cancel" | i18n }}
        </button>
        <button
          bitButton
          buttonType="primary"
          type="submit"
          bitFormButton
          class="bv-account-dialog__save-btn"
        >
          {{ "changeKdf" | i18n }}
        </button>
      </div>
    </div>
  </ng-container>
</form>
